import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";

import { WithdrawComponent } from "./withdraw/withdraw.component";
import { DepositComponent } from "./deposit/deposit.component";
import { WithdrawWithDocumentComponent } from "./withdraw-with-document/withdraw-with-document.component";
import { VoucherExchangeComponent } from "./voucher-exchange/voucher-exchange.component";
import { CardButtonComponent } from "../../components/ui-components/buttons/card-button/card-button.component";
import {
  CardButtonBackground,
  CardButtonSize,
} from "../../components/ui-components/buttons/card-button/card-button.model";
import { WITHDRAW_WITH_DOCUMENT_ROLES } from "../../guards/authorization-policy";
import { SharedModule } from "../../shared.module";

type FinancialDocumentForm =
  | "deposit"
  | "withdraw"
  | "withdrawWithDocument"
  | "voucherExchange"
  | null;

@Component({
  selector: "app-financial-documents",
  templateUrl: "./financial-documents.component.html",
  styleUrls: ["./financial-documents.component.scss"],
  imports: [
    TranslateModule,
    CardButtonComponent,
    CommonModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    WithdrawComponent,
    DepositComponent,
    WithdrawWithDocumentComponent,
    VoucherExchangeComponent,
    SharedModule,
  ],
  standalone: true,
})
export class FinancialDocumentsComponent {
  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;
  readonly withdrawWithDocumentRoles = WITHDRAW_WITH_DOCUMENT_ROLES;

  activeForm: FinancialDocumentForm = null;

  showDeposit() {
    this.activeForm = "deposit";
  }

  showWithdraw() {
    this.activeForm = "withdraw";
  }

  showWithdrawWithDocument() {
    this.activeForm = "withdrawWithDocument";
  }

  showVoucherExchange() {
    this.activeForm = "voucherExchange";
  }

  hideActiveForm() {
    this.activeForm = null;
  }
}
